<template>
  <v-card :key="mode">
    <v-card-text v-if="object">
      <v-container>
        <v-card outlined style="border: 1px solid #1976d2;">
          <div bottom class="text-h6">Datos Generales</div>
          <!-- Fila 1 -->
          <v-row dense>
            <v-col cols="3">
              <v-text-field
                hide-details
                label="Fecha"
                id="date"
                v-model="object.date_formatted"
                disabled
              />
            </v-col>
            <v-col>
              <v-text-field
                disabled
                hide-details
                v-model="object.client_name"
                label="Cliente"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  @click="clientSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <!-- eslint-disable -->
                <v-icon
                  slot="prepend"
                  :class="
                    editing && object.client
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="clientSelected(null)"
                >
                  mdi-close
                </v-icon>
                <!-- eslint-enable -->
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                hide-details
                label="Categoria"
                id="client_category"
                :value="
                  object.client_object
                    ? object.client_object.category_object.description
                    : ''
                "
                disabled
              />
            </v-col>
            <v-col>
              <v-text-field
                disabled
                hide-details
                v-show="editing === false"
                label="Agente"
                :value="dealerDescription"
              >
              </v-text-field>
              <v-autocomplete
                v-show="editing === true"
                :disabled="!editing"
                label="Agente"
                :items="orderDealerItems"
                :loading="orderIsLoadingDealer"
                hide-details
                hide-no-data
                hide-selected
                :item-text="getDealerText"
                v-model="orderSelectedDealer"
                item-value="dealer_data.url"
                return-object
                @change="dealerSelected($event)"
                ref="dealerAutocomplete"
              >
                <!-- eslint-disable -->
                <v-icon
                  slot="prepend"
                  :disabled="!editing || !object.dealer"
                  :class="
                    editing && object.dealer
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="clearAutocomplete('dealerAutocomplete')"
                >
                  mdi-close
                </v-icon>
                <!-- eslint-enable -->
              </v-autocomplete>
            </v-col>
          </v-row>
          <!-- Fila 2 -->
          <v-row dense>
            <v-col cols="3">
              <v-autocomplete
                :disabled="!editing"
                label="Campaña"
                :items="orderCampaignItems"
                hide-details
                hide-no-data
                hide-selected
                item-text="code"
                item-value="url"
                v-model="object.campaign"
                return-object
                @change="campaignSelected($event)"
                ref="campaignAutocomplete"
                prepend-icon="mdi-close"
                @click:prepend="clearAutocomplete('campaignAutocomplete')"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                :disabled="!editing"
                label="Cultivo"
                :items="orderCropItems"
                hide-details
                hide-no-data
                hide-selected
                item-text="description"
                item-value="url"
                v-model="object.crop"
                return-object
                @change="cropSelected($event)"
                ref="cropAutocomplete"
                prepend-icon="mdi-close"
                @click:prepend="clearAutocomplete('cropAutocomplete')"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                disabled
                hide-details
                v-model="object.payment_condition_description"
                label="Condición de Pago"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  @click="paymentConditionSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <v-icon
                  slot="prepend"
                  :class="
                    editing && object.payment_condition
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="paymentConditionSelected(null)"
                >
                  mdi-close
                </v-icon>
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-show="object.requires_broker === true"
                disabled
                hide-details
                v-model="object.broker_name"
                label="Corredor"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  @click="brokerSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <!-- eslint-disable -->
                <v-icon
                  slot="prepend"
                  :class="
                    editing && object.broker
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="brokerSelected(null)"
                >
                  mdi-close
                </v-icon>
                <!-- eslint-enable -->
              </v-text-field>
            </v-col>
          </v-row>
          <!-- Fila 3 -->
          <v-row dense>
            <v-col cols="3">
              <v-text-field
                disabled
                v-show="!editing"
                hide-details
                label="Cantidad Mínima de Bolsas Dto. por Volúmen"
                type="number"
                v-model="object.total_quantity"
              />
              <v-autocomplete
                v-show="editing"
                :disabled="!editing"
                label="Descuento por Volúmen"
                :items="orderScaleItems"
                hide-details
                hide-no-data
                hide-selected
                :item-text="getScaleText"
                item-value="from_quantity"
                v-model="object.total_quantity"
                @change="scaleSelected($event)"
                ref="scaleAutocomplete"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                :disabled="!editing || !object.fidelity_plan"
                hide-details
                :label="d3Description"
                v-model="object.advance_dispatch"
                @change="advanceDispatchChange()"
              />
            </v-col>
            <v-col cols="3" v-if="1 === 2">
              <v-text-field
                disabled
                hide-details
                label="Ventas Totales de la Campaña"
                v-model="object.campaign_total_quantity"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                disabled
                v-show="!editing"
                hide-details
                label="Comprobante"
                v-model="object.document_object.description"
              />
              <v-autocomplete
                v-show="editing"
                :disabled="!editing"
                label="Comprobante"
                :items="orderDocumentItems"
                hide-details
                hide-no-data
                hide-selected
                item-text="description"
                item-value="id"
                v-model="object.document_object.id"
                return-object
                @change="orderDocumentSelected($event)"
                ref="orderDocumentAutocomplete"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-text-field
                disabled
                hide-details
                label="Registración"
                v-model="object.backend_code"
              />
            </v-col>
          </v-row>
          <!-- Fila 4 -->
          <v-row dense>
            <v-col>
              <v-textarea
                :disabled="!editing"
                hide-details
                clearable
                label="Observación Interna"
                v-model="object.internal_comments"
                rows="1"
                auto-grow
              />
            </v-col>
            <v-col>
              <v-textarea
                :disabled="!editing"
                hide-details
                clearable
                label="Texto (IMPRESO EN DOCUMENTACIÓN ENTREGADA AL CLIENTE)"
                v-model="object.comments"
                rows="1"
                auto-grow
                color="red"
              />
            </v-col>
          </v-row>
        </v-card>
        <!-- Datos de Entrega -->
        <v-card
          outlined
          style="border: 1px solid #1976d2;"
          v-if="!object.document_object.inventory_has_client"
        >
          <div bottom class="text-h6">Datos de Entrega</div>
          <!-- Fila 1 -->
          <v-row dense>
            <v-col>
              <v-textarea
                :disabled="!editing"
                hide-details
                v-model="object.address"
                label="Domicilio"
                clearable
                rows="1"
                auto-grow
              />
            </v-col>
            <v-col>
              <!-- eslint-disable -->
              <v-text-field
                disabled
                hide-details
                :value="object.postal_code ? object.postal_code_code + ' - ' + object.postal_code_description : ''"
                label="Código Postal"
              >
                <v-icon
                  slot="append-outer"
                  :class="editing ? 'enabled-icon' : 'disabled-icon'"
                  @click="postalCodeSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <v-icon
                  slot="prepend"
                  :class="
                    editing && object.postal_code
                      ? 'enabled-icon'
                      : 'disabled-icon'
                  "
                  @click="postalCodeSelected(null)"
                >
                  mdi-close
                </v-icon>
              </v-text-field>
              <!-- eslint-enable -->
            </v-col>
          </v-row>
          <!-- Fila 2 -->
          <v-row dense>
            <v-col>
              <v-text-field
                :disabled="!editing"
                hide-details
                label="Nombre de Contacto"
                v-model="object.delivery_contact_name"
              />
            </v-col>
            <v-col>
              <v-text-field
                :disabled="!editing"
                hide-details
                label="Teléfono de Contacto"
                v-model="object.delivery_contact_phone"
              />
            </v-col>
            <v-col>
              <v-menu
                ref="Hdelivery_date_from"
                v-model="object.show_picker_from"
                :close-on-content-click="false"
                :return-value.sync="object.delivery_date_from"
                transition="scale-transition"
                offset-y
                :disabled="!editing"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details="true"
                    label="Fecha Desde"
                    v-model="object.delivery_date_from_formatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="object.delivery_date_from"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="object.show_picker_from = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="HeaderDeliveryDateFromEntered()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                ref="Hdelivery_date_to"
                v-model="object.show_picker_to"
                :close-on-content-click="false"
                :return-value.sync="object.delivery_date_to"
                transition="scale-transition"
                offset-y
                :disabled="!editing"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Fecha Hasta"
                    hide-details
                    v-model="object.delivery_date_to_formatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="object.delivery_date_to"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="object.show_picker_to = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="HeaderDeliveryDateToEntered()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card>
        <!-- Resúmen Cuenta y Orden -->
        <v-card
          outlined
          style="border: 1px solid #1976d2;"
          v-if="object.document_object.code == 'OLP'"
        >
          <div bottom class="text-h6">Cuenta de Venta y Líquido Producto</div>
          <!-- Fila 1 -->
          <v-row dense>
            <v-col cols="12" class="d-flex justify-center align-center">
              <table style="table-layout: auto;">
                <tr>
                  <th style="min-width: 80px;"></th>
                  <th style="min-width: 80px;">Venta Total</th>
                  <th style="min-width: 80px;">Comisión</th>
                  <th style="min-width: 80px;">Venta Neta</th>
                </tr>
                <tr>
                  <td>Subtotales:</td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.subtotal.sale"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.subtotal.commission"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.subtotal.net_sale"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                </tr>
                <tr>
                  <td>IVA:</td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.vat.sale"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.vat.commission"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.vat.net_sale"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                </tr>
                <tr>
                  <td>Totales:</td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.total.sale"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.total.commission"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                  <td style="text-align:right;">
                    <vue-autonumeric
                      :value="object.olp_totals.total.net_sale"
                      :options="{
                        decimalPlaces: '2'
                      }"
                      size="9"
                      style="text-align:right;"
                    ></vue-autonumeric>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <!-- Adjunto -->
              <v-file-input
                v-show="editing"
                v-model="object.invoice_file"
                accept=".pdf"
                :rules="[fileInputValidation]"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card>
        <!-- Items -->
        <v-row dense>
          <v-col cols="12">
            <div class="table-footer-prepend d-flex pl-2 align-center">
              <v-tooltip top>
                <template v-slot:activator="{ activationEvents }">
                  <v-btn
                    icon
                    :disabled="!editing"
                    outlined
                    color="primary"
                    v-on="activationEvents"
                    @click="addNewItem"
                  >
                    <v-icon :class="editing ? 'enabled-icon' : 'disabled-icon'">
                      mdi-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>Agregar</span>
              </v-tooltip>
            </div>
            <v-data-table
              dense
              :headers="orderItemsHeaders"
              :items="object.order_items"
              hide-default-header
            >
              <!-- eslint-disable -->
              <!-- pagination template -->
              <template v-slot:top="{ pagination, options, updateOptions }">
                <v-data-footer
                  :pagination="pagination"
                  :options="options"
                  @update:options="updateOptions"
                />
              </template>
              <!-- eslint-disable -->
              <!-- header template -->
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th
                      v-for="item in headers"
                      :key="item.value"
                      class="column"
                      @click="item.canLock ? changeLock(item.value) : ''"
                      :style="
                        (item.width ? 'width: ' + item.width + '; min-width: ' + item.width + ';' : '')
                      "
                    >
                      {{ item.text }}
                      <v-icon v-if="item.canLock && editing" small>{{ item.locked ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' }}</v-icon>
                    </th>
                  </tr>
                </thead>
              </template>
              <!-- item template -->
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="(item, index) in items" :key="item.item_number">
                    <td v-if="editing">
                      <v-icon v-show="editing" small @click.stop="deleteItem(item)">
                        mdi-delete
                      </v-icon>
                    </td>
                    <td>{{ item.item_number }}</td>
                    <td v-if="editing">
                      <v-icon @click.stop="itemInventorySearchClick(item)">
                        mdi-magnify
                      </v-icon>
                    </td>
                    <td v-if="object.document_object.requires_person">
                      <v-text-field
                        disabled
                        dense
                        hide-details
                        v-model="item.person_name"
                      >
                        <v-icon
                          slot="append-outer"
                          small
                          :class="editing ? 'enabled-icon' : 'disabled-icon'"
                          @click.stop="itemPersonSearchClick(item)"
                        >
                          mdi-magnify
                        </v-icon>
                        <!-- eslint-disable -->
                        <v-icon
                          slot="prepend"
                          small
                          :class="
                            editing && item.person
                              ? 'enabled-icon'
                              : 'disabled-icon'
                          "
                          @click.stop="itemPersonDelete(item)"
                        >
                          mdi-close
                        </v-icon>
                      </v-text-field>
                    </td>
                    <td class="theme--light v-input--is-disabled">{{ item.product_code ? item.product_description : "" }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.gauge_code !== item.gauge_description ? item.gauge_code + " - " + item.gauge_description : item.gauge_code }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.band_data.band_description }}</td>
                    <td>
                      <v-input
                        :disabled="!editing"
                        dense
                        hide-details
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.quantity"
                          :id="
                            'R' + item.item_number.toString() + 'Cquantity'
                          "
                          @input="cellChange(index, 'quantity')"
                          :options = "{
                            decimalPlaces: '0'
                          }"
                          style="text-align:right;"
                          size="5"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td style="border: 1px solid black;">
                      <v-input
                        :disabled="!editing || object.recalc_field == 'unit_price_usd'"
                        dense
                        hide-details
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.unit_price_usd"
                          :id="
                            'R' + item.item_number.toString() + 'Cunit_price_usd'
                          "
                          @input="cellChange(index, 'unit_price_usd')"
                          :options = "{
                            decimalPlaces: '4'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td v-if="object.document_object.disable_leader_discount" class="theme--light v-input--is-disabled">{{ item.transfer_price_usd }}</td>
                    <td>
                      <v-input disabled dense hide-details>
                        <vue-autonumeric
                          slot="default"
                          :value="item.unit_price_usd * item.quantity"
                          :id="
                            'R' +
                              item.item_number.toString() +
                              'Ctotal_item_usd'
                          "
                          :options="{
                            decimalPlaces: '2'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td v-if="orderShowItemPriceSubtotals" class="theme--light v-input--is-disabled" style="border: 1px solid #1976d2;">{{ item.list_unit_price_usd }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.b1_discount }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.b2_discount }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.b3_discount }}</td>
                    <td class="theme--light v-input--is-disabled">{{ item.d1_discount }}</td>
                    <td v-if="orderShowItemPriceSubtotals" class="theme--light v-input--is-disabled" style="border: 1px solid #1976d2;">{{ item.net_unit_price_usd }}</td>
                    <td v-if="!object.document_object.disable_leader_discount">
                      <v-input
                        :disabled="!editing || object.recalc_field == 'leader_discount' || $bRoot.isNullOrEmpty(object, 'dealer')"
                        dense
                        :hide-details="true"
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.leader_discount"
                          :id="
                            'R' + item.item_number.toString() + 'Cleader_discount'
                          "
                          @input="cellChange(index, 'leader_discount')"
                          :options = "{
                            decimalPlaces: '6'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td
                      :style="!$bRoot.isNullOrEmpty(item, 'company_discount') ? 'border: 1px solid #E3002C;' : ''"
                    >
                      <v-input
                        :disabled="!editing || object.recalc_field == 'company_discount'"
                        dense
                        :hide-details="true"
                      >
                        <vue-autonumeric
                          slot="default"
                          v-model="item.company_discount"
                          :id="
                            'R' +
                              item.item_number.toString() +
                              'Ccompany_discount'
                          "
                          @input="cellChange(index, 'company_discount')"
                          :options = "{
                            decimalPlaces: '6'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td>
                      <v-text-field
                        disabled
                        hide-details
                        single-line
                        dense
                        v-model="item.company_discount_motive_description"
                        label="Motivo Dto. LG"
                        :id="
                          'R' +
                            item.item_number.toString() +
                            'Ccompany_discount_motive'
                        "
                      >
                        <v-icon
                          slot="append-outer"
                          :class="(editing && !$bRoot.isNullOrEmpty(item, 'company_discount')) ? 'enabled-icon' : 'disabled-icon'"
                          @click="itemCompanyDiscountMotiveSearchClick(item)"
                        >
                          mdi-magnify
                        </v-icon>
                        <!-- eslint-disable -->
                        <v-icon
                          slot="prepend"
                          :class="
                            editing && item.company_discount_motive
                              ? 'enabled-icon'
                              : 'disabled-icon'
                          "
                          @click="itemCompanyDiscountMotiveSelected(null, item)"
                        >
                          mdi-close
                        </v-icon>
                        <!-- eslint-enable -->
                      </v-text-field>
                    </td>
                    <td
                      v-if="orderShowItemPriceSubtotals"
                      class="theme--light v-input--is-disabled"
                    >
                      {{ item.spot_unit_price_usd }}
                    </td>
                    <td>
                      <v-input disabled dense hide-details>
                        <vue-autonumeric
                          slot="default"
                          :value="item.total_commission_usd"
                          :id="
                            'R' +
                              item.item_number.toString() +
                              'Ctotal_commision_usd'
                          "
                          :options="{
                            decimalPlaces: '2'
                          }"
                          style="text-align:right;"
                          size="8"
                        ></vue-autonumeric>
                      </v-input>
                    </td>
                    <td class="theme--light v-input--is-disabled">
                      {{ item.percentage_commission }}
                    </td>
                    <td
                      class="theme--light v-input--is-disabled"
                      v-if="object.document_object.inventory_has_client"
                    >
                      {{ item.inventory_client_code }}
                    </td>
                  </tr>
                </tbody>
              </template>
              <!-- eslint-enable -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="orderShowSearch"
      :show="orderShowSearch"
      :title="orderSearchOptions.title"
      :endpoint="orderSearchOptions.endpoint"
      :ordering="orderSearchOptions.ordeting"
      :searchLabel="orderSearchOptions.searchLabel"
      :headers="orderSearchOptions.headers"
      :filterString="orderSearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="orderSearchOptions.searchOnURL"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>

    <!-- component for magnify inventory search -->
    <!-- eslint-disable -->
    <inventory-search-dialog
      v-if="orderShowInventorySearch"
      :show="orderShowInventorySearch"
      :campaign="object.campaign_object"
      :crop="object.crop_object"
      :product="object.order_items[orderItemIndex].product"
      :gauge="object.order_items[orderItemIndex].gauge"
      :curing="object.order_items[orderItemIndex].curing"
      :clientItems="
          (object.document_object.inventory_has_client === false ? 
            [] :
            (this.current_level > 2 ?
              (object.dealer_object ? [object.dealer_object] : ($bRoot.appInfo.commercial_person.client_code === object.client_object.code ? [object.client_object] : [])) :
              (object.client_object.category_object.consignee ?
                (object.dealer_object ? [object.dealer_object, object.client_object] : [object.client_object]) :
                (object.dealer_object ? [object.dealer_object] : [])
              )
            )
          )
          "
      :orderDocument="object.document_object"
      :order_id="object.id"
      @itemSelected="itemInventorySelected($event)"
      @cancel="itemInventoryCanceled"
    >
    </inventory-search-dialog>
    <!-- eslint-enable -->
    <!-- component for magnify payment_condition search -->
    <payment-condition-search-dialog
      v-if="orderShowPaymentConditionSearch"
      :show="orderShowPaymentConditionSearch"
      :order="object"
      :disableInterest="true"
      @itemSelected="paymentConditionSelected($event)"
      @cancel="paymentConditionCanceled"
    >
    </payment-condition-search-dialog>
  </v-card>
</template>
<script>
import DataOrder from "@/components/clon/DataOrder.js";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";
import InventorySearchDialog from "@/components/InventorySearchDialog.vue";
import PaymentConditionSearchDialog from "@/components/PaymentConditionSearchDialog.vue";
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  name: "OrderEdit",

  components: {
    PaginatedSearchDialog,
    InventorySearchDialog,
    PaymentConditionSearchDialog,
    VueAutonumeric
  },

  props: ["value", "initialmode"],

  data() {
    return {
      object: null,
      current_level: null,
      editing: false,
      mode: null,
      order: new DataOrder(this.$bRoot),
      orderShowSearch: null,
      orderShowInventorySearch: null,
      orderShowPaymentConditionSearch: null,
      orderItemIndex: null,
      orderSearchOptions: null,
      orderIsLoadingDealer: null,
      orderDealerItems: [],
      orderCampaignItems: [],
      orderCropItems: [],
      orderScaleItems: [],
      orderDocumentItems: [],
      orderFilterItem: null,
      orderFilterDealer: null,
      orderFilterCampaign: null,
      orderFilterCrop: null,
      orderFilterDocument: null,
      orderSelectedDealer: null,
      orderShowItemPriceSubtotals: false,
      d3Description: "Dto.3",
      allOrderItemsHeaders: [
        { text: "", value: "delete", sorteable: false, onlyOnEditing: true },
        { text: "Item", value: "item_number", sortable: false },
        {
          text: "Stock Disponible",
          value: "inventory",
          sorteable: false,
          onlyOnEditing: true
        },
        {
          text: "Comprador",
          value: "person_name",
          sortable: false,
          width: "200px"
        },
        {
          text: "Producto",
          value: "product_code",
          sortable: false,
          width: "200px"
        },
        {
          text: "Calibre",
          value: "gauge_code",
          sortable: false
        },
        {
          text: "Banda",
          value: "band_data.band_description",
          sortable: false,
          width: "150px"
        },
        { text: "Cantidad", value: "quantity", sortable: false },
        {
          text: "Precio Venta Financiado USD",
          value: "unit_price_usd",
          sortable: false,
          canLock: true,
          locked: true
        },
        {
          text: "Precio Transferencia Financiado USD",
          value: "transfer_price_usd",
          sortable: false
        },
        {
          text: "Total Item",
          value: "total_item_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "Precio Lista Contado USD",
          value: "list_unit_price_usd",
          sortable: false,
          align: "end"
        },
        {
          text: "% Dto. Cliente",
          value: "b1_discount",
          sortable: false,
          align: "end",
          visible: true
        },
        {
          text: "% Dto. Volúmen",
          value: "b2_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "Dto.3",
          value: "b3_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "% Dto. Promoción",
          value: "d1_discount",
          sortable: false,
          align: "end"
        },
        {
          text: "Precio Bonificado Contado USD",
          value: "net_unit_price_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "% Descuento Agente",
          value: "leader_discount",
          sortable: false,
          canLock: true,
          locked: false
        },
        {
          text: "% Descuento LG",
          value: "company_discount",
          sortable: false,
          canLock: true,
          locked: false
        },
        {
          text: "Motivo Dto. LG",
          value: "company_discount_motive",
          sortable: false,
          width: "220px"
        },
        {
          text: "Precio Venta Contado USD",
          value: "spot_unit_price_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "Comisión Total",
          value: "total_commission_usd",
          sorteable: false,
          align: "end"
        },
        {
          text: "Comisión Porcentual",
          value: "percentage_commission",
          sorteable: false,
          align: "end"
        },
        {
          text: "Consignatario",
          value: "inventory_client_code",
          sorteable: false,
          align: "end"
        }
      ]
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    editing: {
      handler() {
        this.editingChange();
      }
    },
    deep: true
  },

  computed: {
    orderItemsHeaders() {
      /* eslint-disable */
      return ((this.object ? this.object.document_object.requires_person : false)
        ? this.allOrderItemsHeaders
        : this.allOrderItemsHeaders.filter(
          header => header.text !== 'Comprador'
        )).filter(
          header => this.editing || !header.onlyOnEditing
        ).filter(
          header => this.object
            ? !(this.object.document_object.disable_leader_discount && header.value == 'leader_discount')
            : true
        ).filter(
          header => this.object
            ? !(!this.object.document_object.inventory_has_client && header.value == 'inventory_client_code')
            : true
        ).filter(
          header => this.object
          ? !(!this.object.document_object.disable_leader_discount && header.value == 'transfer_price_usd')
          : true
        ).filter(
          header =>
            this.orderShowItemPriceSubtotals ||
            ![
              "list_unit_price_usd",
              "net_unit_price_usd",
              "spot_unit_price_usd"
            ].includes(header.value)
        );
      /* eslint-enable */
    },
    dealerDescription() {
      return this.object.dealer
        ? this.object.dealer_code + " - " + this.object.dealer_name
        : null;
    }
  },

  methods: {
    async changeLock(value) {
      if (this.object.document_object.disable_leader_discount) {
        value = "leader_discount";
      }
      this.object.recalc_field = value;
      this.orderItemsHeaders.forEach((element, index, items_array) => {
        if (element.canLock === true) {
          items_array[index].locked = element.value === value;
        }
      });
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "dealerAutocomplete":
          this.orderFilterDealer = null;
          this.orderSelectedDealer = null;
          this.object = await this.order.setDealer(this.object);
          break;
        case "campaignAutocomplete":
          this.orderFilterCampaign = null;
          this.object = await this.order.setCampaign(this.object);
          break;
        case "cropAutocomplete":
          this.orderCrop = null;
          this.object = await this.order.setCrop(this.object);
          await this.loadScales();
          break;
      }
    },

    paymentConditionSearchClick() {
      this.orderShowPaymentConditionSearch = true;
    },

    clientSearchClick() {
      this.orderSearchOptions = {
        headers: [
          { text: "Código", value: "client_data.code", sortable: false },
          {
            text: "Identificación",
            value: "client_data.identification",
            sortable: false
          },
          { text: "Nombre", value: "client_data.name", sortable: false },
          {
            text: "Categoría",
            value: "client_data.category_object.description",
            sorteable: false
          }
        ],
        title: "Cliente...",
        endpoint:
          "/data/clients_hierarchy/" + this.object.campaign_id.toString(),
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "clientSelected",
        searchOnURL: true
      };
      this.orderShowSearch = true;
    },

    postalCodeSearchClick() {
      this.orderSearchOptions = {
        headers: [
          { text: "Código", value: "code", sortable: false },
          { text: "Descripción", value: "description", sortable: false }
        ],
        title: "Domicilio de Entrega, Código Postal...",
        endpoint: "/data/postal_codes",
        ordering: "code",
        searchLabel: "Código/Descripción",
        filterString: null,
        selected: "postalCodeSelected",
        searchOnURL: false
      };
      this.orderShowSearch = true;
    },

    brokerSearchClick() {
      this.orderSearchOptions = {
        headers: [
          { text: "Código", value: "code", sortable: false },
          { text: "Nombre", value: "name", sortable: false }
        ],
        title: "Corredor...",
        endpoint: "/data/clients",
        ordering: "name",
        searchLabel: "Identificación/Código/Nombre",
        filterString: "is_broker=true",
        selected: "brokerSelected",
        searchOnURL: false
      };
      this.orderShowSearch = true;
    },

    itemInventorySearchClick(item) {
      if (!this.object.campaign) {
        this.$bRoot.setError("Seleccione Campaña");
      } else if (!this.object.crop) {
        this.$bRoot.setError("Seleccione Cultivo");
      } else if (!this.object.client_object) {
        this.$bRoot.setError("Seleccione Cliente");
      } else {
        // eslint-disable-next-line
        this.orderItemIndex = this.object.order_items.findIndex(oitem => oitem.item_number == item.item_number);
        this.orderShowInventorySearch = true;
      }
    },

    itemCompanyDiscountMotiveSearchClick(item) {
      this.orderItemIndex = this.object.order_items.findIndex(
        oitem => oitem.item_number == item.item_number
      );
      this.orderSearchOptions = {
        headers: [
          { text: "Código", value: "code", sortable: false },
          { text: "Descripción", value: "description", sortable: false }
        ],
        title: "Motivo Descuento LG...",
        endpoint: "/data/company_discount_motives",
        ordering: "description",
        searchLabel: "Descripcion",
        filterString: null,
        selected: "itemCompanyDiscountMotiveSelected",
        searchOnURL: false
      };
      this.orderShowSearch = true;
    },

    async itemPersonSearchClick(item) {
      this.orderItemIndex = this.object.order_items.findIndex(
        oitem => oitem.item_number == item.item_number
      );
      this.orderSearchOptions = {
        headers: [
          { text: "Código", value: "client_code", sortable: false },
          {
            text: "Identificación",
            value: "person_identification",
            sortable: false
          },
          { text: "Nombre", value: "name", sortable: false },
          {
            text: "Categoría",
            value: "person_category_description",
            sorteable: false
          }
        ],
        title: "Cliente/Productores...",
        endpoint: "/data/quotable_persons",
        ordering: null,
        searchLabel: "Código/CUIT/Nombre",
        filterString: null,
        selected: "itemPersonSelected",
        searchOnURL: true
      };
      this.orderShowSearch = true;
    },

    async itemPersonDelete(item) {
      this.orderItemIndex = this.object.order_items.findIndex(
        oitem => oitem.item_number == item.item_number
      );
      this.itemPersonSelected(null);
    },

    itemInventoryCanceled() {
      this.orderItemIndex = null;
      this.orderShowInventorySearch = null;
    },

    paymentConditionCanceled() {
      this.orderShowPaymentConditionSearch = null;
    },

    searchSelected(data) {
      this[this.orderSearchOptions.selected](data, this.orderSearchOptions.row);
      this.searchCanceled();
    },

    searchCanceled() {
      this.orderShowSearch = false;
      this.orderSearchOptions = {};
      this.orderItemIndex = null;
    },

    async paymentConditionSelected(paymentCondition) {
      this.object = await this.order.setPaymentCondition(
        this.object,
        paymentCondition,
        null
      );
      this.paymentConditionCanceled();
    },

    async postalCodeSelected(postalCode) {
      this.object = await this.order.setPostalCode(this.object, postalCode);
    },

    async campaignSelected(campaign) {
      this.orderFilterCampaign = campaign;
      this.object = await this.order.setCampaign(this.object, campaign);
    },

    async cropSelected(crop) {
      this.orderFilterCrop = crop;
      this.object = await this.order.setCrop(this.object, crop);
      await this.loadScales();
    },

    async brokerSelected(broker) {
      this.object = await this.order.setBroker(this.object, broker);
    },

    async clientSelected(client) {
      /*Load dealers*/
      if (client) {
        await this.loadDealers(client.client_data.id);
        this.object = await this.order.clearItems(this.object);
        this.object = await this.order.setClient(
          this.object,
          client.client_data,
          null
        );
        try {
          await this.order.validateClient(this.object);
        } catch (error) {
          if (error) {
            this.$bRoot.setError(error);
          }
        }
      } else {
        this.orderFilterDealer = null;
        this.orderSelectedDealer = null;
        this.orderDealerItems = [];
        this.$refs["dealerAutocomplete"].internalValue = [];
        this.object = await this.order.setClient(this.object);
        this.object = await this.order.setDealer(this.object);
      }
      await this.loadScales();
    },

    async scaleSelected() {
      this.object = await this.order.totalQuantityChange(this.object);
    },

    async loadScales() {
      this.orderScaleItems = await this.order.getDiscountScales(this.object);
    },

    async itemPersonSelected(person) {
      this.object = await this.itemChange(
        this.orderItemIndex,
        "person",
        person
      );
      this.itemInventoryCanceled();
    },

    async loadDealers(client_id) {
      let endpoint =
        "/data/clients_dealers_hierarchy" +
        "/" +
        this.object.campaign_id.toString() +
        "/" +
        client_id.toString();
      this.orderFilterDealer = null;
      this.orderDealerItems = [];
      this.orderIsLoadingDealer = true;
      let res = [];
      if (this.object.document_object.code != "OLP") {
        res = await this.$bRoot.searchAll(endpoint);
      }

      this.orderDealerItems = res;
      this.orderIsLoadingDealer = false;

      /* set default value */
      let leader_id = null;
      let dealer_id = null;
      if (this.object.url) {
        dealer_id = this.object.dealer_id;
      } else {
        if (this.$bRoot.auth.current_level >= 3) {
          // eslint-disable-next-line
          leader_id = (this.$bRoot.auth.current_level === 3 ? this.$bRoot.appInfo.commercial_person.id : this.$bRoot.appInfo.commercial_person.superior_id);
        }
      }
      let index = -1;
      if (dealer_id) {
        index = res.findIndex(item => item.dealer_data.id === dealer_id);
        if (index !== -1) {
          this.orderSelectedDealer = res[index].dealer_data.url;
          this.orderFilterDealer = res[index];
        }
      }

      if (leader_id) {
        // eslint-disable-next-line
        let index = res.findIndex(item => item.commercial_person_id === leader_id);
        if (index !== -1) {
          this.orderSelectedDealer = res[index].dealer_data.url;
          this.orderFilterDealer = res[index];
          this.dealerSelected(this.orderFilterDealer);
        }
      }
    },

    async dealerSelected(dealer) {
      this.object = await this.order.setDealer(
        this.object,
        dealer.dealer_data,
        null
      );
    },

    async advanceDispatchChange() {
      this.object = await this.order.advanceDispatchChange(this.object);
    },

    async totalQuantityChange() {
      this.object = await this.order.totalQuantityChange(this.object);
    },

    async orderDocumentSelected(orderDocument) {
      this.orderFilterDocument = orderDocument;
      this.object = await this.order.setOrderDocument(
        this.object,
        orderDocument
      );
      if (orderDocument.disable_leader_discount) {
        await this.changeLock("leader_discount");
      }
      await this.loadDealers(0);
    },

    async itemInventorySelected(inventory) {
      this.object = await this.itemChange(
        this.orderItemIndex,
        "inventory",
        inventory
      );
      this.itemInventoryCanceled();
    },

    async itemCompanyDiscountMotiveSelected(motive, item) {
      if (!this.orderItemIndex && item) {
        this.orderItemIndex = this.object.order_items.findIndex(
          oitem => oitem.item_number == item.item_number
        );
      }
      this.object = await this.itemChange(
        this.orderItemIndex,
        "company_discount_motive",
        motive
      );
    },

    async itemChange(item_index, fieldName, object) {
      let res = await this.order.itemChange(
        this.object,
        item_index,
        fieldName,
        object
      );
      if (!this.$bRoot.isNullOrEmpty(res, "error")) {
        this.$bRoot.setError(res.error);
      }
      return res.order;
    },

    async addNewItem() {
      this.object = await this.order.addNewItem(this.object);
    },

    async deleteItem(item) {
      this.object = await this.order.deleteItem(this.object, item);
    },

    async cellChange(item_index, field_name) {
      this.$nextTick(async () => {
        if (this.editing) {
          this.object = await this.itemChange(item_index, field_name);
        }
      });
    },

    async HeaderDeliveryDateFromEntered() {
      this.$refs["Hdelivery_date_from"].save(this.object.delivery_date_from);
      let res = await this.order.DeliveryDateFromChange(this.object);
      if (!this.$bRoot.isNullOrEmpty(res, "error")) {
        this.$bRoot.setError(res.error);
      }
      return res.order;
    },

    async HeaderDeliveryDateToEntered() {
      this.$refs["Hdelivery_date_to"].save(this.object.delivery_date_to);
      let res = await this.order.DeliveryDateToChange(this.object);
      if (!this.$bRoot.isNullOrEmpty(res, "error")) {
        this.$bRoot.setError(res.error);
      }
      return res.order;
    },

    async DeliveryDateToEntered(item, index) {
      let ref = "R" + item.item_number.toString() + "Cdelivery_date_to";
      this.$refs[ref][0].save(item.delivery_date_to);
      this.object = await this.itemChange(index, "delivery_date_to");
    },

    async DeliveryDateFromEntered(item, index) {
      let ref = "R" + item.item_number.toString() + "Cdelivery_date_from";
      this.$refs[ref][0].save(item.delivery_date_from);
      this.object = await this.itemChange(index, "delivery_date_from");
    },

    getDealerText(item) {
      if (item.dealer_data) {
        return item.dealer_data.code + " - " + item.dealer_data.name;
      }
    },

    getScaleText(item) {
      if (item) {
        let text =
          (item["from_quantity"]
            ? item["from_quantity"].toString() +
              (item["from_quantity"] <= 1 ? " bolsa" : " bolsas")
            : "") +
          " o más, dto: " +
          (item["percentage"]
            ? parseFloat(item["percentage"]).toFixed(2).toString() //eslint-disable-line
            : "") +
          "%";
        return text;
      } else {
        return "";
      }
    },

    async save() {
      this.$bRoot.errors = null;
      let added = null;
      try {
        added = await this.order.save(this.object, this);
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        if (added) {
          this.object = added;
          this.mode = "show";
          this.editing = false;
          this.$emit("endEdit", added);
        } else {
          this.$emit("actionCanceled", added);
        }
      }
    },

    async changeState(state_code) {
      this.$bRoot.errors = null;
      try {
        await this.order.changeState(this.object, state_code);
        this.$emit("endEdit");
      } catch (error) {
        this.$emit("actionCanceled");
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    },

    async editingChange() {
      //In entering in edit mode load Dealers and Scales
      if (this.editing) {
        await this.loadDealers(this.object.client_id);
        this.orderScaleItems = await this.order.getDiscountScales(this.object);
        if (this.object.document_object.disable_leader_discount) {
          await this.changeLock("leader_discount");
        }
      }
    },

    fileInputValidation(file) {
      this.object.fileError = null;
      if (file && file.size / 1024 > 200) {
        this.object.fileError =
          "El tamaño del archivo debe ser inferior a 200 KB";
      }
      if (this.object.fileError) {
        return this.object.fileError;
      } else {
        return true;
      }
    }
  },

  async mounted() {
    this.mode = this.initialmode;

    // get description for discount code 3
    let DiscountCode = await this.order.getDiscountCode("3");

    if (DiscountCode) {
      this.d3Description = DiscountCode.description;
      this.orderItemsHeaders.forEach((element, index, items_array) => {
        if (element.value === "b3_discount") {
          items_array[index].text = "% " + DiscountCode.description;
        }
      });
    }

    //campaigns
    let campaigns = await this.order.getCampaigns();
    this.orderCampaignItems = campaigns.data.results;

    //crops
    let crops = await this.order.getCrops();
    this.orderCropItems = crops.data.results;

    //documents
    let documents = await this.order.getDocuments();
    this.orderDocumentItems = documents.data.results;
    this.object = this.value;

    if (!this.object.olp_totals) {
      this.$set(this.object, "olp_totals", {
        subtotal: { sale: 0, commission: 0, net_sale: 0 },
        vat: { sale: 0, commission: 0, net_sale: 0 },
        total: { sale: 0, commission: 0, net_sale: 0 }
      });
      this.object = await this.order.olpTotalize(this.object);
    }
    this.current_level = this.$bRoot.auth.current_level;

    this.editing = this.mode === "edit" || this.mode == "new";
    if (this.object.document_object.disable_leader_discount) {
      this.object.recalc_field = "leader_discount";
    } else {
      this.object.recalc_field = "unit_price_usd";
    }
  }
};
</script>
<style>
.inputCol input[type="number"] {
  -moz-appearance: textfield;
  text-align: right;
  width: 60px;
}
.inputCol input::-webkit-outer-spin-button,
.inputCol input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
